<div class="st-full-screen-dialog-left-container">
    <ng-template leftContainerFullScreenContent></ng-template>
</div>
<div class="st-full-screen-dialog-right-container"
     *ngIf="showRightPanel">
    <ng-template rightContainerFullScreenContent></ng-template>
</div>

<div class="st-full-screen-dialog-pager" *ngIf="shouldShowTopicSwitcher || shouldShowTopicSwitcherForCastObjects">
    <button mat-icon-button
            (click)="navigate($event, NavigationDirection.FIRST)"
            class="st-full-screen-dialog-pager-button-first">
        <mat-icon>first_page</mat-icon>
    </button>
    <button mat-icon-button
            (click)="navigate($event, NavigationDirection.PREVIOUS)"
            class="st-full-screen-dialog-pager-button-previous">
        <mat-icon>navigate_before</mat-icon>
    </button>
    <span class="st-full-screen-dialog-pager-text">{{objectType | titlecase}} {{indexInData}}/{{totalCount}}</span>
    <button mat-icon-button
            (click)="navigate($event, NavigationDirection.NEXT)"
            class="st-full-screen-dialog-pager-button-next">
        <mat-icon>navigate_next</mat-icon>
    </button>
    <button mat-icon-button
            (click)="navigate($event, NavigationDirection.LAST)"
            class="st-full-screen-dialog-pager-button-last">
        <mat-icon>last_page</mat-icon>
    </button>
</div>